import http from 'hub-http/clients/apiClient';

// TODO: change to dashboard/v2/favorite/all if we want to show dashboards too
// else use exitsing favorites api
const BASE_URL = 'dashboard/v2/favorite/reports';
export const fetchFavoriteAssets = () => http.get(BASE_URL);